var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-grey",attrs:{"variant":"outline-light"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }